import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { Confirmable } from '@app/modules/ui/models/confirmable'
import { UIModule } from '@app/modules/ui/ui.module'
import { MemberService } from '@app/services/member.service'

@Component({
  selector: 'sb-message-photo-unlock-insufficient-credits-modal',
  templateUrl: './message-photo-unlock-insufficient-credits-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoUnlockInsufficientCreditsModalComponent extends Confirmable {
  readonly memberService = inject(MemberService)
}
